import React from "react";
import "./Preloader.css";

const Preloader = () => {
  return (
    <div className="preloader-container">
      <div className="spinner-wrapper">
        <div className="spinner" />
        <div className="spinner-inner" />
      </div>
      <div className="preloader-content">
        <h2 className="preloader-title">Cargando</h2>
        <div className="loading-dots">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </div>
  );
};

export default Preloader;